import createManager from 'kandy-logger'
import defaultOptions from './config'

// Logs generated as a result of invoking the public API will contain this tag
export const API_LOG_TAG = 'API invoked: '

/**
 * Create the LogManager right away so that it is available. The SDK has not
 *    been instantiated yet, so we have to use the default options until we get
 *    the application's configs.
 */
/**
 * TODO: There is a technical debt associated with having a loggerManager along with it's
 * loggers created at the global scope. Multiple instances of the SDK would end up sharing
 * the log manager and therefore loggers.
 */
const manager = createManager(defaultOptions)
export const logManager = manager
